import { globalTrackerAPIRoot, oxfordStringencyAPIRoot } from 'Constants/locations';
import { useEffect, useState } from 'react';

import App from './App';
import fetchJson from 'Utils/fetchJson';

const PageRoot = (props) => {
  const { country } = props;

  const [globalStatistics, setGlobalStatistics] = useState(props.globalStatistics);
  const [nationalCounts, setNationalCounts] = useState(props.nationalCounts);
  const [oxfordStringency, setOxfordStringency] = useState(null);

  useEffect(() => {
    const refetchData = async() => {
      const [
        globalStatistics,
        nationalCounts,
        oxfordStringency,
      ] = await Promise.all([
        fetchJson(`${globalTrackerAPIRoot}/statistics.json`),
        fetchJson(`${globalTrackerAPIRoot}/countries/${country}/counts/all.json`),
        fetchJson(`${oxfordStringencyAPIRoot}/countries/${country}/data.json`),
      ]);
      setGlobalStatistics(globalStatistics);
      setNationalCounts(nationalCounts);
      setOxfordStringency(oxfordStringency);
    };
    refetchData();
  }, [country]);

  return (
    <App {...{
      ...props,
      globalStatistics,
      nationalCounts,
      oxfordStringency,
      publicPrefix: process.env.NODE_ENV === 'production' ? '' : '',
    }}
    />
  );
};

export default PageRoot;
